export enum PublishingStatus {
    Published = "PUBLISHED",
    Draft = "DRAFT",
    Archived = "ARCHIVED",
    Deleted = "DELETED"
}